import { gql } from "@/__generated__/gql";

export const RISE_COMMIT_INDEX_SUMMARY = gql(`
query riseCommitIndexSummary($orgId: ID!, $cohortYear: Int!, $inCommunity: YesNoEnum) {
  node(id: $orgId) {
    id
    ... on Organization {
      rise {
        commitIndexSummary(cohortYear: $cohortYear, inCommunity: $inCommunity) {
          low {
            state
            value
          }
          mediumLow {
            state
            value
          }
          medium {
            state
            value
          }
          mediumHigh {
            state
            value
          }
          high {
            state
            value
          }
        }
      }
    }
  }
}
`);
